import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  Modal,
  Typography,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("md")]: {
      // backgroundColor: "white",
    },
  },
  modalRoot: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    outline: "none",
    [theme.breakpoints.down("md")]: {
      maxHeight: "90vh",
      width: "90vw",
    },
  },
}));

const CommonModal = (props) => {
  const classes = useStyles();
  const { title, open } = props;
  console.log("common modal props", props);
  return (
    <div className={classes.root}>
      <Modal
        open={open}
        onClose={() => props.onClose()}
        className={classes.modalRoot}
      >
        <Card className={classes.card}>
          <CardHeader
            title={
              <Typography variant="h6" color="primary">
                {title}
              </Typography>
            }
            action={
              <IconButton onClick={() => props.onClose()}>
                <Close />
              </IconButton>
            }
          />
          <Divider />
          <CardContent>{props.children}</CardContent>
        </Card>
      </Modal>
    </div>
  );
};
export default CommonModal;
